import {nanoid} from "nanoid"

const defaultPvanlage = () => ({
    id: nanoid(),
})

export const PhotovoltaikActions = ({
                                        getDataFromPointer,
                                        updateData,
                                    }) => {
    return {
        ADD_PVANLAGE: () => updateData(
            [
                ...(getDataFromPointer("/photovoltaikanlagen") ?? []),
                defaultPvanlage(),
            ],
            "/photovoltaikanlagen",
        ),
    }
}